import { Box, Label, Text, useColorModeValue as mode, VStack } from '@chaine/keychaine';
import moment from 'moment';
import React from 'react';
import { Popup } from 'react-map-gl';
const AvailableLoadPopup = (props) => {
    const { loadDetails, coordinates } = props;
    return (React.createElement(Popup, { style: { width: '100%' }, latitude: coordinates?.latitude ?? 0, longitude: coordinates?.longitude ?? 0, closeButton: false, offset: 10 },
        React.createElement(VStack, { spacing: 1, alignItems: 'flex-start', borderRadius: "11px", borderWidth: "1px", px: 2, py: 2, bg: mode('white', 'black') },
            React.createElement(Box, { width: "100%", justifyContent: "space-between", display: "flex", pb: 1 },
                React.createElement(Text, { fontSize: "sm", color: mode('text.light.primary', 'text.dark.primary'), fontWeight: "bold" }, loadDetails.details),
                React.createElement(Label, null,
                    " ",
                    loadDetails.equipment)),
            React.createElement(Box, { width: "100%", justifyContent: "space-between", display: "flex", pb: 1 },
                React.createElement(Text, { fontSize: "sm", color: mode('text.light.primary', 'text.dark.primary'), fontWeight: "bold" },
                    "Delivers in ",
                    loadDetails.destinationCity),
                React.createElement(Text, { fontSize: "xs", color: 'text.secondary' }, loadDetails.weight)),
            React.createElement(Box, null,
                React.createElement(Text, { fontSize: "xs", color: 'text.secondary' }, moment(loadDetails.destinationAppointmentDate).format('MMM DD')),
                React.createElement(Text, { fontSize: "xs", color: 'text.secondary' }, loadDetails.destinationCity)),
            React.createElement(Box, null))));
};
AvailableLoadPopup.displayName = 'AvailableLoadPopup';
export { AvailableLoadPopup };
